/**
 * URLs DE OBJETO TEMPORALES (FASE 5.6 §41)
 *
 * Registro mínimo de los `blob:` creados con `URL.createObjectURL` a
 * partir de contenido DESCIFRADO (documentos/evidencias offline) — para
 * poder revocarlos todos de golpe al bloquear el perfil, cambiar de
 * perfil o cerrar sesión, sin que cada pantalla tenga que llevar su
 * propia cuenta.
 *
 * Deliberadamente NO vive dentro de `perfil.ts`: ese módulo sólo es
 * responsable de la DEK y del estado de bloqueo (ver su propio
 * comentario en `bloquearPerfilActivo`); quien reacciona al bloqueo para
 * limpiar URLs es `PuertaOfflineSegura` (`paginas/offline-perfil.tsx`),
 * que ya es la responsable de desmontar el contenido protegido (§42).
 *
 * LÍMITE CONOCIDO: revocar la URL impide que se RESUELVA de nuevo, pero
 * si ya se abrió en una pestaña/visor que cargó el contenido en su propia
 * memoria, revocar no borra esa copia ya renderizada — eso excede lo que
 * el propio navegador permite hacer desde aquí, y es coherente con el
 * threat model de esta fase (§3: no hay protección frente a una vista ya
 * abierta con la sesión desbloqueada).
 */

const urls = new Set<string>();

export function registrarUrlTemporal(url: string): void {
  urls.add(url);
}

export function revocarUrlTemporal(url: string): void {
  URL.revokeObjectURL(url);
  urls.delete(url);
}

export function revocarTodasLasUrlsTemporales(): void {
  for (const url of urls) URL.revokeObjectURL(url);
  urls.clear();
}
